import { useLayoutEffect, useState } from 'react';

export function usePreviewOutOfSync(documentId: string, fileUrl: string): boolean {
  const [committed, setCommitted] = useState(() => ({ documentId, fileUrl }));

  const outOfSync =
    Boolean(documentId.trim()) &&
    (!fileUrl.trim() || (committed.documentId !== documentId && committed.fileUrl === fileUrl));

  useLayoutEffect(() => {
    const stillStale = committed.documentId !== documentId && committed.fileUrl === fileUrl && Boolean(fileUrl.trim());
    if (stillStale) {
      return;
    }
    /* eslint-disable react-hooks/set-state-in-effect -- advance committed snapshot after stale window */
    setCommitted({ documentId, fileUrl });
    /* eslint-enable react-hooks/set-state-in-effect */
  }, [committed.documentId, committed.fileUrl, documentId, fileUrl]);

  return outOfSync;
}
